import React from 'react';

const ToolbarButton = ({ icon, label, onClick }) => {
  return (
    <button onClick={onClick} className="flex flex-col items-center justify-center gap-1 min-w-[64px] h-[52px] rounded-md hover:bg-slate-700/50 text-slate-300 hover:text-white transition-colors px-2 group">
      <div className="group-hover:-translate-y-0.5 transition-transform">{icon}</div>
      <span className="text-[10px] font-medium">{label}</span>
    </button>
  );
};

export default ToolbarButton;
